import { PolicyUnion } from '../types';

type InputPolicies<R> = {
  genericRequirements: Array<PolicyUnion<R>>,
  crossDataRequirements: {
    title: string,
    policies: Array<PolicyUnion<R>>
  },
  charRequirements: {
    title: string,
    policies: Array<PolicyUnion<R>>
  },
  charProhibitions: {
    title: string,
    policies: Array<PolicyUnion<R>>
  },
};

export const composePolicies = <R>({
  genericRequirements,
  crossDataRequirements,
  charRequirements,
  charProhibitions,
}: InputPolicies<R>): Array<PolicyUnion<R>> => {
  const composed: Array<PolicyUnion<R>> = [];

  if (genericRequirements.length) {
    composed.push(...genericRequirements);
  }

  if (crossDataRequirements.policies.length) {
    composed.push(crossDataRequirements);
  }

  if (charRequirements.policies.length) {
    composed.push(charRequirements);
  }

  if (charProhibitions.policies.length) {
    composed.push(charProhibitions);
  }

  return composed;
};
